import { Component, Input, OnChanges, OnInit, SimpleChanges, inject, input, output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfigurationHandlerService } from '../../../core/configuration-handler.service';
import { MultiLanguageService } from '../../../parts/multi-language/multi-language.service';
import { MappingTable } from '../../../shared/interfaces/mapping-table.interface';
import { CvTemplateHeaderDTO } from '../../../shared/external-model/cv/cv-template-header-dto';
import { CvCreationService } from '../cv-creation.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, LoadingSlateComponent, ActionListItemComponent, ActionListItemActionComponent } from '@exl-ng/mulo-common';
import { catchError, EMPTY } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { MediaService, SystemDateFormatService } from '@exl-ng/mulo-core';
import { TranslateObjectPipe } from '../../../shared/pipes/translate-object.pipe';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatRadioButton } from '@angular/material/radio';
import { ListitemDescriptionA11yDirective } from '../../../shared/directives/a11y/description/listitem-description-a11y.directive';
import { MatList } from '@angular/material/list';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'esp-cv-template',
    templateUrl: './cv-template.component.html',
    styleUrls: ['./cv-template.component.scss'],
    imports: [
        LoadingSlateComponent,
        FormsModule,
        ReactiveFormsModule,
        MatList,
        ActionListItemComponent,
        ListitemDescriptionA11yDirective,
        MatRadioButton,
        ActionListItemActionComponent,
        MatButton,
        MatIcon,
        DatePipe,
        TranslateModule,
        TranslateObjectPipe
    ]
})
export class CvTemplateComponent implements OnInit, OnChanges {
    private cvCreationService = inject(CvCreationService);
    private multiLanguageService = inject(MultiLanguageService);
    private configurationHandlerService = inject(ConfigurationHandlerService);
    private fb = inject(FormBuilder);
    private matDialog = inject(MatDialog);
    private translate = inject(TranslateService);
    media = inject(MediaService);
    systemDateSvc = inject(SystemDateFormatService);

    readonly nextStep = output<void>();
    readonly templateChange = output<string>();
    readonly templateId = input<string>(undefined);
    readonly otbTemplates = input<CvTemplateHeaderDTO[]>(undefined);
    readonly userTemplates = input<CvTemplateHeaderDTO[]>(undefined);
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() form: FormGroup;

    languages = [];
    readonly loading = input(true);

    constructor() {
        const fb = this.fb;

        this.form = fb.group({ template: null, language: null });
    }

    ngOnInit(): void {
        const institutionLanguagesMT =
            this.configurationHandlerService.getMappingTable(
                'esploro_InstitutionLanguages'
            ) as MappingTable[];
        this.languages = institutionLanguagesMT
            .filter((row) => row.source2 === 'true' && row.enabled === 'true')
            .map((row) => {
                return {
                    twoLetterCode: row.target,
                    threeLetterCode: this.multiLanguageService.get3CharLanguage(
                        row.target
                    ),
                };
            });
    }

    ngOnChanges(changes: SimpleChanges) {}

    onTemplateSelectionChange(event) {
        this.templateChange.emit(event);
    }

    showRemoveConfirmationDialog(templateIndex, label) {
        // using t for translate function to increase readability
        const t = (code, params?) => this.translate.instant(code, params);

        this.matDialog
            .open(ConfirmDialogComponent, {
                data: {
                    title: t('research.aria.delete.button', { value: label }),
                    message: t('research.delete.confirmation.message'),
                    actions: {
                        cancel: t('research.delete.confirmation.cancel'),
                        confirm: t('research.delete.confirmation.confirm'),
                    },
                },
            })
            .afterClosed()
            .subscribe((res) => {
                if (res === 'ok') {
                    this.cvCreationService
                        .deleteTemplate(this.userTemplates()[templateIndex].id)
                        .pipe(
                            catchError((error: HttpErrorResponse) => {
                                console.error(error);
                                return EMPTY;
                            })
                        )
                        .subscribe((data) => {
                            this.userTemplates().splice(templateIndex, 1);
                        });
                }
            });
    }
}
